module.exports = __webpack_public_path__ + "img/winningAnimation.1f8c4c73.gif";